/**
 * Created by evgenijsenkevic on 27.08.2024
 * */

const AdminLocationsScene = cc.Scene.extend({
    ctor: function () {
        this._super();

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            styling: {
                scale9: bundles.admin.frames.background
            },
            bundles: this.listBundles(),
            sceneName: cleverapps.Environment.SCENE_ADMINISTRATOR
        }));
    },

    onSceneLoaded: function () {
        const adminLocationsView = new AdminLocationsView(cleverapps.administrator.adminLocations);
        this.addChild(adminLocationsView);

        cleverapps.administrator.adminLocations.on("updateActiveLocation", this.createListener(this.updateActiveLocation.bind(this)));

        const log = new AdminLogView();
        this.addChild(log);
        log.setAlignment({ align: "center" }, { align: "bottom" });
        this.updateActiveLocation();
        this.createGlobalButtons();
        if (cleverapps.git) {
            cleverapps.git.changeFolders(GitManager.FOLDERS.LEVELS);
        }
    },

    createGlobalButtons: function () {
        if (cleverapps.git) {
            this.addChild(new GitButtonsView({
                direction: cleverapps.UI.VERTICAL
            }), 1);
        }
    },

    updateActiveLocation: function () {
        if (this.activeLocationView) {
            this.activeLocationView.removeFromParent();
            this.activeLocationView = undefined;
        }

        const location = cleverapps.administrator.adminLocations.activeLocation;
        if (!location) {
            return;
        }

        this.activeLocationView = new AdminActiveLocationView(location);
        this.addChild(this.activeLocationView);
    },

    onCloseAction: function () {
        cleverapps.config.adminMode = false;
        cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();
        cleverapps.setUrlHash({
            mode: undefined
        });
    },

    listBundles: function () {
        return ["admin", "game"];
    }
});

AdminLocationsScene.getUrlHashData = function () {
    return {
        mode: "admin_locations"
    };
};

AdminLocationsScene.open = function (f) {
    const action = [
        function (f) {
            cleverapps.setUrlHash(AdminLocationsScene.getUrlHashData());
            cleverapps.config.adminMode = true;
            cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();
            connector.ads.closeStickyCallback();
            cleverapps.scenes.replaceScene(new AdminLocationsScene(), f);
        }
    ];

    if (f) {
        cleverapps.focusManager.compound(f, action);
    } else if (cleverapps.focusManager.isFocused()) {
        cleverapps.focusManager.distract({
            focus: "adminLocation",
            actions: action
        });
    } else {
        cleverapps.focusManager.display({
            focus: "adminLocation",
            actions: action
        });
    }
};